import { JSX } from 'react'
import { useSelector } from 'react-redux'

import { NotificationContainer } from 'core-components/library/popup'
import { ViewError } from 'src/core/components/app/Error'
import { selectAuthError } from 'src/core/store/selectors/selectAuthError'

interface IViewErrorWrapper {
  children: JSX.Element
}

export const ViewErrorWrapper = ({ children }: IViewErrorWrapper) => {
  const authError = useSelector(selectAuthError)

  if (authError.message) {
    return (
      <>
        <NotificationContainer />
        <ViewError message={authError.message} reloadPageButtonVisible={true} />
      </>
    )
  }

  return children
}
